import { UserStorage } from './../user/user-storage';
import { AuthenticationState } from './../authentication/authentication-state';
import {Component, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import {UrlBuilder} from '../core/url-builder/url-builder';
import { Settings, Link, CorporateMandate} from '../core/settings';
import { map, publishReplay, refCount } from 'rxjs/operators';

@Component({
    selector: 'footer',
    template: require('./footer.component.html'),
    styles: [require('./footer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
    public copyright: CorporateMandate;
    public version: CorporateMandate;
    public privacyLink: Link;
    public contactUsLink: Observable<Link>;
    public termsAndConditionsLink: string[];
    public disclaimerLink: string[];
    public queryParams$: Observable<Params>;
    public isAuthenticated$: Observable<boolean>;
    public isUserLoggedIn: boolean;

    constructor(urlBuilder: UrlBuilder, settings: Settings, authState: AuthenticationState, route: ActivatedRoute, userStorage: UserStorage) {
        this.queryParams$ = route.queryParams;
        this.copyright = settings.corporateMandatesDictionary['copyright'];
        this.version = settings.corporateMandatesDictionary['version'];
        this.privacyLink = settings.linksDictionary['privacy-policy'];
        this.isAuthenticated$ = authState.authInfo.pipe(map(a => a.isAuthenticated));
        this.isAuthenticated$.subscribe(val => { this.isUserLoggedIn = val; });
        if (this.isUserLoggedIn) {
            this.contactUsLink = userStorage.currentUser
                .pipe(
                    map(u => u.isSponsor ? settings.linksDictionary['contact-us-sponsor'] : settings.linksDictionary['contact-us']),
                    publishReplay(1),
                    refCount());
        } else {
            this.contactUsLink = settings.getSubDomain()
                .pipe(
                    map(appSubDomain => appSubDomain === 'xsp' ? settings.linksDictionary['contact-us-sponsor'] : settings.linksDictionary['contact-us']),
                    );
        }
        this.termsAndConditionsLink = urlBuilder.esa().globalPopup().terms().url();
        this.disclaimerLink = urlBuilder.esa().globalPopup().portaldisclaimer().url();
    }
}